import React from 'react';
import PropTypes from 'prop-types';
import * as style from './ArticleDivider.module.scss';
import ArticleImageBlock from '../ArticleImageBlock';

const ArticleDivider = (props) => {
  const { className, ...rest } = props;

  return (
    <div {...rest} className={`${style.dividerWrapper} ${className}`}>
      <div className={style.divider} />
    </div>
  );
};

ArticleImageBlock.defaultProps = {
  className: '',
};

ArticleImageBlock.propTypes = {
  /** Optional class name */
  className: PropTypes.string,
};

export default ArticleDivider;
